/**
 * The far end of a conversation, as a screen shows it. The number is stored exactly as received (owner, 2026-10-28:
 * even an unverifiable one) and masked only in the view; a person whose role may not see it gets the server's own
 * masked form (`party_masked`, `+30***1391`) and never the number.
 *
 * Moved from the portal's `apps/web-app/src/routes/numbers/{number-display,number-row-copy}.ts` (plan-034 VIEW-PKG),
 * which re-export {@link displayNumberOf} and {@link maskedPartyOf}. "Number hidden" and its kind are words each app
 * holds.
 */
/**
 * `+14155550142` → `+1 415 555 0142`. Only the North American plan is grouped (its shape is fixed at 3-3-4); any other
 * number is shown as stored rather than grouped by a guess.
 */
export function displayNumberOf(e164) {
    const nanp = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164);
    if (nanp === null)
        return e164;
    return `+1 ${nanp[1] ?? ""} ${nanp[2] ?? ""} ${nanp[3] ?? ""}`;
}
/** `+39 ··· 0688` — the far end with the middle withheld, as the prototype writes it; anything else as stored. */
export function maskedPartyOf(partyAddress) {
    const display = displayNumberOf(partyAddress);
    if (!/^\+\d{6,}$/.test(partyAddress))
        return display;
    const country = partyAddress.startsWith("+1") ? "+1" : partyAddress.slice(0, 3);
    return `${country} ··· ${partyAddress.slice(-4)}`;
}
/** The server's masked form wins (the person may not see the number); else the number, displayed and masked. */
export function partyShownOf(party) {
    if (party.partyMasked !== null)
        return { kind: "masked_by_server", masked: party.partyMasked };
    if (party.partyAddress !== null) {
        return { kind: "address", full: displayNumberOf(party.partyAddress), masked: maskedPartyOf(party.partyAddress) };
    }
    return { kind: "hidden" };
}
//# sourceMappingURL=party-mask.js.map